/**
 * Which upload rows the Forms tab shows for a team member, by role.
 *
 * Each entry is { label, name } where `name` is the field the uploaded file's
 * path is stored in. An optional `emptyText` overrides the "No file selected"
 * wording while nothing is attached.
 *
 * Storage note: every field here is a column on TEAM except
 * REAL_ESTATE_LICENSE_FORM, which lives on its own TEAM_LICENSES table and is
 * loaded / saved separately by CRUDTeamMember.
 *
 * Claritask 547010 (client comment): DRAW was added for Summit Agents, between
 * Payroll and Real Estate License, reading "N/A" until a pdf is uploaded. It is
 * Agent-only because that is the only role whose tab has a Real Estate License
 * for it to sit before.
 *
 * CommonJS (not ESM) so the config can be unit-tested with the node-backend
 * test harness; Babel's interop lets TeamMemberUploadDocInfo.js `import` it.
 */

var ROLE_SUMMIT_AGENT = 'a';
var ROLE_SUMMIT_EMPLOYEE = 'e';
var ROLE_PEAK_AGENT = 'p';
var ROLE_PEAK_EMPLOYEE = 'q';
var ROLE_HSC = 'h';
var ROLE_LEGACY_AGENT = 'y';
var ROLE_LEGACY_EMPLOYEE = 'n';

var W9 = { label: 'W9', name: 'W9_FORM' };
var W4 = { label: 'W4', name: 'W4_FORM' };
var PAYROLL = { label: 'Payroll', name: 'PAYROLL_FORM' };
var DRAW = { label: 'DRAW', name: 'DRAW_FORM', emptyText: 'N/A' };
var REAL_ESTATE_LICENSE = { label: 'Real Estate License', name: 'REAL_ESTATE_LICENSE_FORM' };

var summitAgentForms = [W9, PAYROLL, DRAW, REAL_ESTATE_LICENSE];
var summitEmployeeForms = [W4, PAYROLL];
var peakAgentForms = [W9, PAYROLL];
var peakEmployeeForms = [W4, PAYROLL];
var hscForms = [W9, PAYROLL];

/**
 * Forms for a role code. Unknown or missing roles fall back to the Summit
 * Employee set, which is what the tab did before this was extracted.
 */
function getFormsForRole(role) {
    switch (role) {
        case ROLE_SUMMIT_AGENT:
        case ROLE_LEGACY_AGENT:
            return summitAgentForms;
        case ROLE_SUMMIT_EMPLOYEE:
        case ROLE_LEGACY_EMPLOYEE:
            return summitEmployeeForms;
        case ROLE_PEAK_AGENT:
            return peakAgentForms;
        case ROLE_PEAK_EMPLOYEE:
            return peakEmployeeForms;
        case ROLE_HSC:
            return hscForms;
        default:
            return summitEmployeeForms;
    }
}

module.exports = {
    getFormsForRole: getFormsForRole,
    summitAgentForms: summitAgentForms,
    summitEmployeeForms: summitEmployeeForms,
    peakAgentForms: peakAgentForms,
    peakEmployeeForms: peakEmployeeForms,
    hscForms: hscForms,
};
